module.exports = __webpack_public_path__ + "static/kitchen-silly-square.8e1b8906.jpg";